module.exports = __webpack_public_path__ + "img/zone-pink.1baed9e1.png";